import { Card, CardContent, Typography, Box, Skeleton } from '@mui/material';
import { AdminMetricCardProps } from '../../../types/admin';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import TrendingDownIcon from '@mui/icons-material/TrendingDown';

/**
 * AdminMetricCard - Display key metrics with trend indicators
 *
 * Features:
 * - Title and value display
 * - Optional icon
 * - Trend indicator (up/down)
 * - Loading state
 * - Click handler
 *
 * TODO: Add animation on value change
 * TODO: Add tooltip for additional info
 */
export default function AdminMetricCard({
  title,
  value,
  subtitle,
  icon,
  color,
  trend,
  loading,
  onClick,
}: AdminMetricCardProps) {
  if (loading) {
    return (
      <Card>
        <CardContent>
          <Skeleton variant="text" width="60%" />
          <Skeleton variant="text" width="40%" height={40} />
          <Skeleton variant="text" width="50%" />
        </CardContent>
      </Card>
    );
  }

  return (
    <Card
      sx={{
        cursor: onClick ? 'pointer' : 'default',
        '&:hover': onClick
          ? {
              boxShadow: 3,
              transform: 'translateY(-2px)',
              transition: 'all 0.2s',
            }
          : {},
      }}
      onClick={onClick}
    >
      <CardContent>
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
          {icon && <Box sx={{ mr: 1, color }}>{icon}</Box>}
          <Typography variant="body2" color="text.secondary">
            {title}
          </Typography>
        </Box>

        <Typography variant="h4" sx={{ mb: 1, color }}>
          {value}
        </Typography>

        {subtitle && (
          <Typography variant="body2" color="text.secondary">
            {subtitle}
          </Typography>
        )}

        {trend && (
          <Box sx={{ display: 'flex', alignItems: 'center', mt: 1 }}>
            {trend.direction === 'up' ? (
              <TrendingUpIcon color="success" fontSize="small" />
            ) : (
              <TrendingDownIcon color="error" fontSize="small" />
            )}
            <Typography
              variant="body2"
              sx={{
                ml: 0.5,
                color: trend.direction === 'up' ? 'success.main' : 'error.main',
              }}
            >
              {trend.value > 0 ? '+' : ''}
              {trend.value}% {trend.label}
            </Typography>
          </Box>
        )}
      </CardContent>
    </Card>
  );
}
